import React from "react";
import Stats from "./stats"
import DesktopVideo from './images/videos/PMG_Hero_Desktop.webm';
import TabletVideo from './images/videos/PMG_Hero_Tablet.webm';
import MobileVideo from './images/videos/PMG_Hero_Mobile.webm';

class Hero extends React.Component {
    render() {
        return (
            <div className="w-screen h-screen overflow-hidden relative">
                <video autoPlay muted playsInline title="Partnered Management Group — Fractional Project Management" className="absolute w-screen h-full object-cover z-0">
                    <source src={MobileVideo} autoPlay muted type="video/webm" media="(max-width: 768px)"/>
                    <source src={TabletVideo} autoPlay muted type="video/webm" media="(min-width: 769px) and (max-width: 1024px)"/>
                    <source src={DesktopVideo} autoPlay muted type="video/webm" media="(min-width: 1025px)"/>
                </video>
                <div className="absolute top-0 left-0 bottom-0 z-10 flex flex-col items-start justify-end gap-6 p-[30px] lg:pb-32 h-full w-full bg-homeHeroGradient bg-cover bg-center">
                    <div className="text-left flex flex-col gap-6">
                        <h1 className="text-4xl lg:text-5xl font-light text-white pointer-events-none leading-tight"><span className="font-bold">A Hands-On Partner</span><br/>for Every Part of Your Business.</h1>
                        <p className="text-base lg:text-xl text-white10 pointer-events-none max-w-2xl leading-normal">We know what it takes to deliver. Our practitioners bring experience and care to your project management, operations, and creative execution.</p>
                    </div>
                    <div className="flex flex-row w-full">
                        <Stats />
                    </div>
                </div>
            </div>
        );
    }
}

export default Hero;
